import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        corpName: null // 企业名称
      },
      // 查询表单基础数据
      formSearchList: [
        {
          label: "项目名称：",
          value: "prjName",
          type: "input",
          placeholder: "请输入",
        },
        {
          label: "招标人：",
          value: "tenderCorp",
          type: "input",
          placeholder: "请输入",
        },
        {
          label: "招标代理机构：",
          value: "tenderAgentOrganName",
          type: "input",
          placeholder: "请输入",
        },
        {
          label: "招标类别：",
          value: "tenderClassNum",
          type: "select",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "201510200918460003"
          },
        },
        {
          label: "招标方式：",
          value: "tenderTypeNum",
          type: "select",
          placeholder: "请输入",
          queryParams: {
            url: "/dataDictionaryEntries/BasicDataCombobox",
            zdid: "201507131544540011"
          },
        },
        {
          label: "行政监督部门：",
          value: "regulators",
          type: "select",
          placeholder: "请选择",
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201604141747323854"
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          isShow: true,
          fixed: true,
          width: "300",
        },
        {
          label: "标段号",
          prop: "section",
          width: "80",
          fixed: true,
        },
        {
          label: "招标人",
          prop: "tenderCorpName",
          width: "200",
        },
        {
          label: "招标联系人",
          prop: "tenderLinkMan",
          width: "150",
        },
        {
          label: "招标代理机构",
          prop: "tenderAgentOrganName",
          width: "200",
        },
        {
          label: "代理机构联系人",
          prop: "agencyLinkMan",
          width: "150",
        },
        {
          label: "行政监督部门",
          prop: "regulatorsName",
          width: "300",
        },
        {
          label: "招标类别",
          prop: "tenderClassNumName",
          width: "150",
        },
        {
          label: "招标方式",
          prop: "tenderTypeNumName",
          width: "120",
        },
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0
    };
  },

  // 接收父组件传递的数据
  props: {},

  // 模板编译完成
  mounted() {
    // 获取列表一览数据
    this.fun_GetList();
  },

  // 自定义方法
  methods: {
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/projectInfo/getNotTerminatedProjectList", {
        ...this.form,
        ...this.reqPageData,
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },

    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },

    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },

    /**
     * 已发公告（未终止）的项目选择
     * @author shuhua
     */
    fun_NotTerminatedProjectChoose(e) {
      // 回调函数
      this.$nextTick(() => {
        // 赋值父页面数据
        this.$parent.fun_NotTerminatedProject(e.val);
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    }
  }
};
